import styled from 'styled-components';
import tw from 'twin.macro';

/* The section along the bottom of a card that holds the members of its set.
 * The members themselves are ChildBooking* in ListViewChildBooking.style. */

/* The summary line of the card's set, which is also what opens and closes it.
   It reads as a link, and the chevron takes that colour from here: the button
   itself is text-current. */
export const CardChildrenSummary = styled.div(tw`text-blue-base`);

/* The members of the card's set: a band of its own along the bottom of the
   card, full-bleed across the card's padding so the line above it reads as a
   divider of the card rather than as a box inside it */
export const CardChildren = styled.div(
  tw`-mx-16 -mb-16 mt-16 px-16 py-8 bg-silver-lighten-30 rounded-b border-0 border-t border-solid border-silver-lighten-20`
);
